export enum CalculationType {
  displacement = 'displacement',
  resultantSpeed = 'resultantSpeed',
  acceleration = 'acceleration',
  angle = 'angle',
  angularVelocity = 'angularVelocity',
  angularAcceleration = 'angularAcceleration'
}
